var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "alert", class: _vm.classes }, [
    _vm.message
      ? _c("div", {
          staticClass: "alert__message",
          domProps: { innerHTML: _vm._s(_vm.message) }
        })
      : _c("div", { staticClass: "alert__message" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }